export default __webpack_public_path__ + "static/media/planning_team.6ee0452c.png";